import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";

const FleetUtilizationHistory = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [fleetUtilizationHistoryApi, setFleetUtilizationHistoryApi] = useState([]);
  const [searchVehicle, setSearchVehicle] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const columns = [
    { field: "registrationNo", headerName: "Vehicle Registration", minWidth: 250 },
    { field: "bookFrom", headerName: "Booked From", minWidth: 200 },
    { field: "bookTo", headerName: "Booked To", minWidth: 200 },
    { field: "createdAt", headerName: "Created At", minWidth: 200 },
    {
      field: "totalRevenue",
      headerName: "Revenue",
      minWidth: 150,
      renderCell: (params) => (
        <span>{Number(params.value || 0).toFixed(2)}</span>
      ),
    },
    { field: "totalDays", headerName: "Total Days", minWidth: 150 },
  ];

  function createData(
    id,
    registrationNo,
    bookFrom,
    bookTo,
    createdAt,
    totalRevenue,
    totalDays
  ) {
    return {
      id,
      registrationNo,
      bookFrom,
      bookTo,
      createdAt,
      totalRevenue,
      totalDays,
    };
  }

  const rows =
    fleetUtilizationHistoryApi?.map((item) =>
      createData(
        item?.id,
        item?.registrationNo || "-",
        item?.bookFrom || "-",
        item?.bookTo || "-",
        item?.createdAt || "-",
        item?.totalRevenue ?? 0,
        item?.totalDays ?? 0
      )
    ) || [];

  useEffect(() => {
    getFleetUtilizationHistory();
  }, [paginationModel.page, paginationModel.pageSize, searchVehicle]);
  

  const getFleetUtilizationHistory = async () => {
    try {
      setLoading(true);

      const { page, pageSize } = paginationModel;
      const offset = page * pageSize;

      const registrationQuery = searchVehicle
        ? `&registrationNo=${searchVehicle}`
        : "";

      const response = await fetch(
        `${apiUrl}/api/fleetutilizationhistory?limit=${pageSize}&offset=${offset}${registrationQuery}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        }
      );

      const data = await response.json();

      if (data?.entities?.rows) {
        setFleetUtilizationHistoryApi(data.entities.rows);
        setTotalCount(data.entities.count || 0);
      } else {
        setFleetUtilizationHistoryApi([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching fleet utilization history:", error);
      setFleetUtilizationHistoryApi([]);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ margin: "30px 0" }}>
      <div
        style={{
          padding: "15px 20px",
          fontSize: "20px",
          fontWeight: "600",
        }}
      >
        Fleet Utilization History Details
      </div>

      <div
        style={{
          margin: "20px 10px",
          display: "flex",
          gap: "15px",
          alignItems: "center",
        }}
      >
        <input
          type="text"
          placeholder="Search by Vehicle Registration"
          value={searchVehicle}
          onChange={(e) => {
            setSearchVehicle(e.target.value);
            setPaginationModel({ ...paginationModel, page: 0 });
          }}
          style={{ padding: "8px", minWidth: "250px" }}
        />

        <button
          onClick={() => {
            setSearchVehicle("");
            setPaginationModel({ ...paginationModel, page: 0 });
          }}
          style={{
            padding: "8px 15px",
            cursor: "pointer",
            width: "80px",
            height: "40px",
            backgroundColor: "#f44336",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
          }}
        >
          Clear
        </button>
      </div>

      <Commongrid
        rows={rows}
        columns={columns}
        totalCount={totalCount}
        loading={loading}
        handleViewClick={() => {}}
        api={getFleetUtilizationHistory}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        disableColumnMenu={true}
      />
    </div>
  );
};

export default FleetUtilizationHistory;